/**
 * The biggest user-uploaded procedural-timeline file we'll accept (50MB).
 */
export const MAX_PROCEDURAL_FILE_SIZE_BYTES = 50 * 1024 * 1024;

/** MIME types the procedural-timeline extractor supports. */
export const ALLOWED_PROCEDURAL_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;
